export default __webpack_public_path__ + "static/media/check-icon.9e7d8b3b.svg";